<template>
    <v-app>
        <v-toolbar app class="app-toolbar">
            <v-btn icon @click="$router.go(-1)">
                <v-icon class="icon-light">arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title>Legal Documents</v-toolbar-title>
        </v-toolbar>
        <v-content>
            <v-container id="document-content">
                <v-layout row>
                    <v-flex xs-12>
                        <p class="description">Please select which documents you would like us to send from the list below</p>

                        <v-list subheader one-line>
                            <v-list-tile v-for="(document, index) in documents" @click="" :key="index">
                                <v-list-tile-action>
                                    <v-checkbox v-model="document.selected"></v-checkbox>
                                </v-list-tile-action>

                                <v-list-tile-content @click="document.selected = !document.selected">
                                    <v-list-tile-title>{{ document.name }}</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-flex>
                </v-layout>
            </v-container>
            <div id="document-footer">
                <v-container>
                    <v-layout row full-width align-center justify-center>
                        <v-flex xs-12>
                            <v-btn class="vas-btn" block @click="sendRequest">Request Documents</v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>
        </v-content>
        <v-snackbar
                v-model="snackbar.visible"
                :bottom="true"
                :left="false"
                :multi-line="false"
                :right="false"
                :timeout="5000"
                :top="false"
                :vertical="false">

            {{ snackbar.message }}

            <v-btn flat @click="snackbar.visible = false">
                Close
            </v-btn>
        </v-snackbar>

        <v-dialog max-width="500" v-model="responseMessageVisible" :persistent="true">
            <v-card>
                <v-card-text>
                    We have received your document request. We will send you the requested documents once we are done preparing them.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="responseDone">
                        Okay
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
    import vas from "@/lib/VASClient"
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                responseMessageVisible: false,
                snackbar: {
                    visible: false
                },
                documents: [
                    {
                        name: 'Contractor Agreements',
                        selected: false
                    },
                    {
                        name: 'Letters Of Demand',
                        selected: false
                    },
                    {
                        name: 'Service Level Agreements',
                        selected: false
                    },
                    {
                        name: 'Employee Contracts',
                        selected: false
                    },
                    {
                        name: 'Wills & Testaments',
                        selected: false
                    },
                    {
                        name: 'Affidavits',
                        selected: false
                    }
                ]
            }
        },
        created() {

        },
        methods: {
            responseDone() {
                this.responseMessageVisible = false;
                this.$router.go(-1);
            },
            sendRequest() {
                var self = this;
                var toSend = {};
                var hasDocs = false;

                for (var i in this.documents) {
                    if (this.documents[i].selected) {
                        toSend['document[' + this.documents[i].name + ']'] = true;

                        hasDocs = true;
                    }
                }

                if (!hasDocs) {
                    Snackbar.show("Please select at least one document");
                    return;
                }

                Loading.show();

                vas.documentRequest(this.auth.user.cell_no, this.auth.user.user_id, toSend).then(function (result) {
                    self.responseMessageVisible = true;


                    // Snackbar.show("Your documents have been requested");
                    // self.$router.go(-1);
                    Loading.hide();
                }).catch(function () {
                    self.responseMessageVisible = true;

                    // self.$router.go(-1);

                    Loading.hide();
                });
            }
        },
        computed: {
            ...mapState(
                ['auth']
            )
        }
    }
</script>

<style>
    #document-footer {
        position: fixed;
        bottom: 0px;
        width: 100vw;
        height: 100px;
    }

    #document-content {
        padding-bottom: 100px;
    }
</style>